import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=d6d8b9c0&scoped=true&"
import script from "./SimpleTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=d6d8b9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d8b9c0",
  null
  
)

export default component.exports